// 组件对象，大写
import editRemarks from './editRemarks.vue'
export default editRemarks
